import React, { useState, useEffect } from "react";
import { ReactComponent as EyeCross } from "../../assets/eyeCross.svg";
import { ReactComponent as Eye } from "../../assets/fi-rr-eye.svg";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch, useSelector } from "react-redux";
import { lowerFirst, useDisclosure } from "@mantine/hooks";
import SuccessPopUp from "../../components/SuccessPopUp";
import { error } from "pdf-lib";
import { logout } from "../../components/Reducers/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "@mantine/core";

const ManagePersonalInfo = () => {
  const { user, client_token } = useSelector((state) => state.user);
  console.log(user, client_token);
  const [opened, { open, close }] = useDisclosure(false);
  const [opened2, { open: open2, close: close2 }] = useDisclosure(false);
  const [opened3, { open: open3, close: close3 }] = useDisclosure(false);

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [showNewConfirmPassword, setShowNewConfirmPassword] = useState(false);
  const [newConfirmPassword, setNewConfirmPassword] = useState("");
  const [changePasswordError, setChangePasswordError] = useState(null);
  const [personalDetailsError, setPersonalDetailsError] = useState(null);
  const [
    deleteModalOpened,
    { open: deleteAccountOpen, close: deleteAccountClose },
  ] = useDisclosure(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState(user?.first_name || "");
  const [lastName, setLastName] = useState(user?.last_name || "");
  const [phoneNumber, setPhoneNumber] = useState(user?.phone_number || "");
  const [email, setEmail] = useState(user?.email || "");

  const [personalInfoErrors, setPersonalInfoErrors] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });

  const [passwordErrors, setPasswordErrors] = useState({
    currentPassword: "",
    newPassword: "",
    newConfirmPassword: "",
  });

  const handle403error = (err) => {
    if (err) {
      if (err.response) {
        if (
          Number(err?.response?.status) === 403 ||
          Number(err?.response?.status) === 401
        ) {
          setTimeout(() => {
            console.log("Unauthorized or forbidden. Logging out.");
            dispatch(logout());
            // localStorage.clear();
            localStorage.setItem("from_403_status", "call_toast");
            navigate("/login");
            // toast.warn("Session Expired");
            toast.success("Token Expired");
          }, 1000);
        }
      }
    }
  };

  const handleUserInfoUpdate = async () => {
    setPersonalDetailsError(null);

    let errors = {};

    if (!firstName.trim()) errors.firstName = "First name is required";
    if (!lastName.trim()) errors.lastName = "Last name is required";
    if (!phoneNumber.trim()) errors.phoneNumber = "Phone number is required";
    else if (phoneNumber.trim().length < 10)
      errors.phoneNumber = "Phone number should be of 10 digits";
    if (!email.trim()) errors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(email))
      errors.email = "Invalid email format";
    // else if (user?.email !== email) errors.email = "Email is not valid";

    if (Object.keys(errors).length > 0) {
      setPersonalInfoErrors(errors);
      return;
    }

    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        setPersonalDetailsError("Token not found!");
        navigate("/login");
      }

      const response = await axios.post(
        `${base_url.api1}/users/update_user`,
        {
          id: user.id,
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone_number: phoneNumber,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      );

      console.log("user updated successfully", response.data);
      open();
      setPersonalInfoErrors({});
    } catch (err) {
      setPersonalDetailsError(err.response?.data?.message);
      if (error.response?.status === 403) {
        dispatch(logout());
        navigate("/login");
      }
    }
  };

  const validatePassword = (password) => {
    const minLength = /.{6,}/;

    if (!minLength.test(password)) {
      return "Password must be at least 6 characters long.";
    }

    return null;
  };

  const handleChangePassword = async () => {
    setChangePasswordError(null);
    setPasswordErrors({});
    let errors = {};

    if (!currentPassword.trim())
      errors.currentPassword = "Current password is required";
    if (!newPassword.trim()) errors.newPassword = "New password is required";
    if (!newConfirmPassword.trim())
      errors.newConfirmPassword = "Confirm password is required";
    else {
      const passwordError = validatePassword(newPassword);
      if (passwordError) errors.newPassword = passwordError;
    }

    if (newPassword !== newConfirmPassword) {
      errors.newConfirmPassword = "Passwords do not match";
    }

    if (currentPassword.trim() === newPassword.trim()) {
      errors.newPassword =
        "Sorry, your new password cannot be the same as your old password";
    }
    if (Object.keys(errors).length > 0) {
      setPasswordErrors(errors);
      return;
    }

    try {
      const token = localStorage.getItem("client_token");
      if (!token) {
        setPersonalDetailsError("Token not found!");
        navigate("/login");
      }

      const response = await axios.post(
        `${base_url.api1}/users/change_password`,
        {
          email: user.email,
          old_password: currentPassword,
          password: newPassword,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      );

      if (response.data.status_code !== 200) {
        setChangePasswordError(response.data.message);
        return;
      }

      setPasswordErrors({});
      open2();
      setCurrentPassword("");
      setNewConfirmPassword("");
      setNewPassword("");
      console.log("Password changed successfully", response.data);
    } catch (err) {
      setChangePasswordError(err.response?.data?.message);
      console.error("Error:", err.response?.data || err.message);
      handle403error(err);
    }
  };

  const handleUserInfoCancelClick = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setPersonalInfoErrors({});
  };

  const handleChangePassCancelClick = () => {
    setCurrentPassword("");
    setNewConfirmPassword("");
    setNewPassword("");
    setPasswordErrors({});
  };
  // --------------------------- notification preferences

  const [emailSelected, setEmailSelected] = useState(false);
  const [phoneSelected, setPhoneSelected] = useState(false);
  const [smsSelected, setSmsSelected] = useState(false);
  const [notification, setNotification] = useState(false);
  const [backdropopen, setbackdropopen] = useState(false);

  const toggleSelection = (type) => {
    if (type === "Email") setEmailSelected((prev) => !prev);
    if (type === "Phone") setPhoneSelected((prev) => !prev);
    if (type === "SMS") setSmsSelected((prev) => !prev);
  };

  const handleNotificationClick = () => {
    setNotification((prev) => !prev);
    setEmailSelected(false);
    setPhoneSelected(false);
    setSmsSelected(false);
  };

  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isEnableDeleteAccount, setIsEnableDeleteAccount] = useState(false);
  useEffect(() => {
    if (password.trim()) {
      setIsEnableDeleteAccount(false);
    } else {
      setIsEnableDeleteAccount(true);
    }
  }, [password]);

  useEffect(() => {
    const getUserData = async () => {
      setbackdropopen(true);
      try {
        const token = localStorage.getItem("client_token");

        if (!token) {
          // setPersonalDetailsError("Token not found!");
          navigate("/login");
        }

        const res = await axios.get(
          `${base_url.api1}/users/get_user?id=${user.id}`,
          {
            headers: {
              Authorization: `JWT ${token}`,
              Origin: "https://flyandclaim.odisoft.in",
            },
          }
        );
        const data = res.data.user;

        setFirstName(data.first_name || "");
        setLastName(data.last_name || "");
        setEmail(data.email || "");
        setPhoneNumber(data.phone_number || "");

        if (
          !data.email_notification &&
          !data.phone_notification &&
          !data.sms_notification
        ) {
          setNotification(false);
        } else {
          setNotification(true);
          setEmailSelected(data.email_notification);
          setPhoneSelected(data.phone_notification);
          setSmsSelected(data.sms_notification);
        }
        setbackdropopen(false);
      } catch (error) {
        setbackdropopen(false);
        console.log(error);
        handle403error(error);
      }
    };
    getUserData();
  }, []);

  const handleSaveClick = async () => {
    setbackdropopen(true);
    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        // setPersonalDetailsError("Token not found!");
        navigate("/login");
      }

      const response = await axios.post(
        `${base_url.api1}/users/update_user`,
        {
          id: user.id,
          email_notification: emailSelected,
          sms_notification: smsSelected,
          phone_notification: phoneSelected,
          email: user.email,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      );

      console.log("user updated successfully", response.data);
      setbackdropopen(false);
      open3();
    } catch (err) {
      setbackdropopen(false);
      console.log(err);
      handle403error(err);
    }
  };
  const handleDeleteAccount = async () => {
    setbackdropopen(true);
    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        // setPersonalDetailsError("Token not found!");
        navigate("/login");
      }

      const response = await axios.post(
        `${base_url.api1}/users/delete_user`,
        {
          id: user.id,
          password: password,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      );

      console.log("user delete successfully", response.data);
      setbackdropopen(false);
      if (response?.data.status_code == 400) {
        setPasswordErr(response?.data?.message);
        return;
      }

      setTimeout(() => {
        deleteAccountClose();
        dispatch(logout());
        // localStorage.clear();

        navigate("/login");

        toast.success("Account Deleted");
      }, 1000);
    } catch (err) {
      setbackdropopen(false);
      deleteAccountClose();

      console.log(err);
      handle403error(err);
    }
  };

  return (
    <>
      <div className="manage-wrapper">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Modal
          opened={deleteModalOpened}
          onClose={deleteAccountClose}
          centered
          radius={"lg"}
          size={"md"}
          withCloseButton={false}
        >
          <div className="delete-modal-wrapper">
            {/* <CircleTickIcon /> */}
            <h5 className="delete-text">Confirm account deletion</h5>

            <h6
              style={{
                color: "#314064",
                fontSize: "14px",
                textAlign: "left",
                marginTop: "-20px",
              }}
            >
              Your account will be permanently deleted.
            </h6>

            <div className="custom-input " style={{ width: "100%" }}>
              <label className="input-label">
                Enter password<span style={{ color: "#de8385" }}> *</span>
              </label>
              <div className="input-box">
                <input
                  className="save-progress-input"
                  placeholder="Enter your password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <EyeCross /> : <Eye />}
                </button>
              </div>

              {/* <p style={{ textAlign: "right" }}>
                <sapn
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/login/forgot-password")}
                >
                  Forgot Password?
                </sapn>
              </p> */}

              {passwordErr && (
                <p
                  style={{
                    textlign: "left",
                    color: "#D04244",
                    fontSize: "14px",
                  }}
                >
                  {passwordErr}
                </p>
              )}
            </div>

            <div className="logout-btn-wrapper">
              <CustomButton
                style={{ width: "50%" }}
                btnText={"Cancel"}
                flex={1}
                onClick={deleteAccountClose}
                type="secondary"
              />

              <CustomButton
                style={{ width: "50%" }}
                btnText={"Delete"}
                flex={1}
                disabled={isEnableDeleteAccount}
                onClick={handleDeleteAccount}
                type="danger"
              />
            </div>
          </div>
        </Modal>
        <h3 className="account-header">Manage personal information</h3>

        <ToastContainer />

        <div className="manage-personal-info">
          <h5 className="account-sub-header">Personal information</h5>

          <div className="manage-personal-info-container">
            <div className="manage-personal-info-input">
              <div style={{ width: "100%" }}>
                <label>
                  First name (as on ticket){" "}
                  <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your first name"
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
                {personalInfoErrors.firstName && (
                  <p style={{ color: "#D04244", fontSize: "14px" }}>
                    {personalInfoErrors.firstName}
                  </p>
                )}
              </div>
              <div style={{ width: "100%" }}>
                <label>
                  Last name (as on ticket){" "}
                  <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your last name"
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
                {personalInfoErrors.lastName && (
                  <p style={{ color: "#D04244", fontSize: "14px" }}>
                    {personalInfoErrors.lastName}
                  </p>
                )}
              </div>
            </div>
            <div className="manage-personal-info-input">
              <div style={{ width: "100%" }}>
                <label>
                  Phone number <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your phone number"
                    value={phoneNumber}
                    type="text"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                      setPhoneNumber(value);
                    }}
                    maxLength={10}
                    required
                  />
                </div>
                {personalInfoErrors.phoneNumber && (
                  <p style={{ color: "#D04244", fontSize: "14px" }}>
                    {personalInfoErrors.phoneNumber}
                  </p>
                )}
              </div>
              <div style={{ width: "100%" }}>
                <label>
                  Email address <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {personalInfoErrors.email && (
                  <p style={{ color: "#D04244", fontSize: "14px" }}>
                    {personalInfoErrors.email}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div style={{ marginTop: "5px" }}>
            {personalDetailsError ? (
              <p style={{ textAlign: "center", color: "#D04244" }}>
                {personalDetailsError}
              </p>
            ) : (
              <p></p>
            )}
          </div>
        </div>

        <div className="manage-buttons-container">
          <CustomButton
            onClick={handleUserInfoCancelClick}
            type="secondary"
            btnText={"RESET"}
          />
          <CustomButton onClick={handleUserInfoUpdate} btnText={"SAVE"} />
        </div>

        {/* change pass container  */}
        <div className="manage-change-pass-container">
          <h5 className="account-sub-header">Change password</h5>

          <div>
            <div className="custom-input password-wrapper">
              <label className="input-label">
                Current password<span style={{ color: "#de8385" }}> *</span>
              </label>
              <div className="input-box">
                <input
                  className="save-progress-input"
                  placeholder="Enter your current password"
                  type={showCurrentPassword ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showCurrentPassword ? <EyeCross /> : <Eye />}
                </button>
              </div>
              {passwordErrors.currentPassword && (
                <p
                  style={{
                    textlign: "left",
                    color: "#D04244",
                    fontSize: "14px",
                  }}
                >
                  {passwordErrors.currentPassword}
                </p>
              )}
              <p style={{ textAlign: "right" }}>
                <sapn
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/login/forgot-password")}
                >
                  Forgot Password?
                </sapn>
              </p>
            </div>

            {/* new pass container  */}
            <div className="manage-new-pass-container">
              <div className="custom-input password-wrapper">
                <label className="input-label">
                  New password <span style={{ color: "#de8385" }}> *</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your new password"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {showNewPassword ? <EyeCross /> : <Eye />}
                  </button>
                </div>
                {passwordErrors.newPassword && (
                  <p
                    style={{
                      textlign: "left",
                      color: "#D04244",
                      fontSize: "14px",
                    }}
                  >
                    {passwordErrors.newPassword}
                  </p>
                )}
              </div>
              <div className="custom-input password-wrapper">
                <label className="input-label">
                  Confirm new password{" "}
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <div className="input-box">
                  <input
                    className="save-progress-input"
                    placeholder="Enter your new password"
                    type={showNewConfirmPassword ? "text" : "password"}
                    value={newConfirmPassword}
                    onChange={(e) => setNewConfirmPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() =>
                      setShowNewConfirmPassword(!showNewConfirmPassword)
                    }
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {showNewConfirmPassword ? <EyeCross /> : <Eye />}
                  </button>
                </div>
                {passwordErrors.newConfirmPassword && (
                  <p
                    style={{
                      textlign: "left",
                      color: "#D04244",
                      fontSize: "14px",
                    }}
                  >
                    {passwordErrors.newConfirmPassword}
                  </p>
                )}
              </div>
            </div>
            <div style={{ marginTop: "5px" }}>
              {changePasswordError ? (
                <p style={{ textAlign: "left", color: "#D04244" }}>
                  {changePasswordError}
                </p>
              ) : (
                <p></p>
              )}
            </div>
          </div>
        </div>
        <div className="manage-buttons-container">
          <CustomButton
            onClick={handleChangePassCancelClick}
            type="secondary"
            btnText={"RESET"}
          />
          <CustomButton onClick={handleChangePassword} btnText={"SAVE"} />
        </div>

        <button
          className="delete-account-btn desktop-wrapper"
          onClick={deleteAccountOpen}
        >
          Delete Account
        </button>
        <SuccessPopUp
          opened={opened2}
          close={close2}
          messageText="Password changed successfully!"
          messagePara="Your password is changed successfully."
        />
        <SuccessPopUp
          opened={opened}
          close={close}
          messageText="Details Updated Successfully!"
          messagePara="Your details are Updated Successfully."
        />
        <SuccessPopUp
          opened={opened3}
          close={close3}
          messageText="Notification Updated Successfully!"
          messagePara="Your notification prefrences have been Updated Successfully."
        />
      </div>
      <div
        className="manage-wrapper mobile-wrapper"
        style={{ marginTop: "30px" }}
      >
        <h3 className="account-header">Notification preferences</h3>

        <div>
          <div className="manage-personal-info notifications-container">
            <h5 className="account-sub-header">Notifications</h5>
            <div
              className="notification-email-container"
              style={{ alignItems: "center" }}
            >
              <p>Notification updates</p>
              <label class="switch">
                <input
                  type="checkbox"
                  checked={notification}
                  onChange={() => handleNotificationClick()}
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <hr />
          {/* change pass container  */}
          <div className="manage-change-pass-container ">
            <h5 className="account-sub-header">Set preferred contact method</h5>

            <div className="notification-ratio-container">
              <div className="radio-input-wrapper notification-ratio-button">
                <input
                  type="radio"
                  id="Email"
                  value="Email"
                  name="Email"
                  checked={emailSelected}
                  onChange={() => toggleSelection("Email")}
                  disabled={!notification}
                />
                <label htmlFor="Email">Email</label>
              </div>
              <div className="radio-input-wrapper notification-ratio-button">
                <input
                  type="radio"
                  id="Phone"
                  value="Phone"
                  name="Phone"
                  checked={phoneSelected}
                  onChange={() => toggleSelection("Phone")}
                  disabled={true}
                  // disabled={!notification}
                />
                <label htmlFor="Phone">Phone</label>
              </div>
              <div className="radio-input-wrapper notification-ratio-button">
                <input
                  type="radio"
                  id="SMS"
                  value="SMS"
                  name="SMS"
                  checked={smsSelected}
                  onChange={() => toggleSelection("SMS")}
                  disabled={true}
                  // disabled={!notification}
                />
                <label htmlFor="SMS">SMS</label>
              </div>
            </div>
          </div>
        </div>
        <div className="manage-buttons-container">
          <CustomButton btnText={"SAVE"} onClick={() => handleSaveClick()} />
        </div>

        <button
          className="delete-account-btn mobile-wrapper"
          onClick={deleteAccountOpen}
        >
          Delete Account
        </button>
      </div>
    </>
  );
};

export default ManagePersonalInfo;
